import { css } from '@emotion/react';

import { theme } from '../../theme';

const styles = {
  container: (columns: number, fitContent: boolean, background?: string) => css`
    background: ${background ? background : theme.colors.white};
    border-radius: 18px;
    display: grid;
    gap: ${theme.spacing.xs};
    grid-template-columns: repeat(${columns}, 1fr);
    width: ${fitContent ? 'auto' : '100%'};
    align-items: center;
  `,
  button: (selected: boolean) => css`
    cursor: pointer;
    border-radius: 18px;
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    background-color: ${selected ? theme.colors.blue[1] : undefined};
    color: ${selected ? theme.colors.white : theme.colors.blue[1]};
    padding: ${theme.spacing.sm} ${theme.spacing.lg};
    text-align: center;

    &:focus,
    &:hover {
      background-color: ${selected ? theme.colors.blue[1] : undefined};
      color: ${selected ? theme.colors.white : theme.colors.blue[1]};
    }
  `,
};

type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Option[];
  selected: string;
  onChange: (value: string) => void;
  fitContent: boolean;
  background?: string;
};

export const ButtonGroup = ({ options, selected, onChange, fitContent, background }: Props) => {
  return (
    <div css={styles.container(options.length, fitContent, background)}>
      {options.map(option => {
        const checked = selected === option.value;

        return (
          <button
            className="reset"
            id={option.value}
            onClick={() => {
              onChange(option.value);
            }}
            value={option.value}
            css={styles.button(checked)}
            key={option.value}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
